
export const getExperience = store => {
    if (!store.experience) {
        return null;
    }
    return store.experience.experience;
}